import { PrimaryButton } from "@/components/buttons/PrimaryButton";
import { PencomRoutes } from "@/router";
import { useNavigate } from "react-router-dom";

const ReportSubmissionSuccessPage = () => {
    const navigate = useNavigate();

    return (
        <div className="w-full min-h-full flex flex-col items-center justify-center py-12">
            <div className="flex flex-col items-center gap-y-10 max-w-[460px] w-full">
                <div className="flex flex-col items-center gap-y-6 w-full">
                    <img
                        src="/assets/icons/solid-check.svg"
                        alt="Success"
                        className="w-10 h-10 shrink-0"
                    />
                    <div className="flex flex-col items-center gap-y-4 w-full">
                        <h2 className="text-2xl font-semibold font-clash-display text-medium-dark-grey tracking-[-0.36px] leading-tight text-center">
                            Submission Successful
                        </h2>
                        <div className="flex flex-col gap-y-3 text-base">
                            <p className="font-clash-display text-sm text-medium-dark-grey leading-[18px] tracking-[-0.07px]">
                                PenCom will review your submission and contact
                                you via email if additional information is
                                required.
                            </p>
                            <p className="font-clash-display mt-5 font-medium text-sm text-medium-dark-grey leading-[18px] tracking-[-0.07px]">
                                Your Registration will remain on hold until this
                                request has been reviewed.
                            </p>
                        </div>
                    </div>
                </div>

                <PrimaryButton
                    className="w-full"
                    title="Return to Home"
                    onClick={() => navigate(PencomRoutes.LOGIN)}
                />
            </div>
        </div>
    );
};

export default ReportSubmissionSuccessPage;
